import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import BdHeader from './components/BdHeader';
import BdFooter from './components/BdFooter';
import { AppRoutes } from './routes';
import { useAdminAuth } from './context/AdminAuthContext';
import { BASE_PATH } from './config/constants';

const App = () => {
  const { isLoggedIn, setIsLoggedIn, isAdmin, setIsAdmin } = useAdminAuth();
  const location = useLocation();

  useEffect(() => {
    const storedLoggedIn = localStorage.getItem('loggedIn') === 'true';
    const storedRole = localStorage.getItem('role') || 'user';
    setIsLoggedIn(storedLoggedIn);
    setIsAdmin(storedRole === 'admin');
  }, [setIsLoggedIn, setIsAdmin]);

  // En React Router, location.pathname NO incluye el basename, solo el path relativo
  // Así que si basename="/ligaincom" y estamos en /ligaincom/bd, location.pathname será "/bd"
  const isBdRoute = location.pathname.startsWith('/bd') || location.pathname === '/bd';

  return (
    <>
      {isBdRoute ? <BdHeader /> : <Header />}
      <main>
        <AppRoutes isLoggedIn={isLoggedIn} isAdmin={isAdmin} />
      </main>
      {isBdRoute ? <BdFooter /> : <Footer />}
    </>
  );
};

export default App;
